import qrcodeIcon from '../img/qr_code-24px.svg';

const QrCodeIcon = ({ 
  onClick = () => {}
}) => (
  <img src={qrcodeIcon} alt="QR code icon" onClick={onClick} />
);

export default QrCodeIcon;
